import React from 'react';
import { Modal, Button } from 'grab-ui';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import cx from 'classnames';
import warningCircleYellow from 'public/icons/warning-circle-yellow.svg';
import css from './offer-warning-modal.less';

const OfferWarningModal = ({ handleClose, visible, handleSubmit }) => (
  <div className={cx(css.modalContainer, css.offerWarningModalContainer)}>
    <Modal
      className={cx(css.modalContainer, css.offerWarningModalContainer)}
      centered
      visible={visible}
      onOk={handleClose}
      footer={[
        <div className={css.footerContainer} key="buttons">
          <div key="ok" className={cx(css.btnContainer)}>
            <Button
              type="primary"
              className={cx(
                css.cancelButton,
                css.keepButton,
                css.smallButton,
                css.modalButton,
              )}
              key="keep"
              onClick={handleClose}
            >
              <span>
                {I18n.t('v2.anytimeBooking.offers.modal.seeOtherOffers')}
              </span>
            </Button>
          </div>

          <div key="cancel" className={cx(css.btnContainer)}>
            <Button
              className={cx(css.smallButton, css.modalButton)}
              key="keep"
              onClick={handleSubmit}
            >
              <span>
                {I18n.t(
                  'phrase.offers.mktplace_offers_button_cta_edge_case_handling',
                )}
              </span>
            </Button>
          </div>
        </div>,
      ]}
      maskStyle={{ backgroundColor: 'rgba(28, 28, 28, 0.5)' }}
    >
      <div className={css.modalContainer}>
        <div className={css.iconContainer}>
          <img className={css.iconClass} src={warningCircleYellow} alt="" />
        </div>
        <div className={css.infoContainer}>
          <h3>
            {I18n.t(
              'phrase.offers.mktplace_offers_heading_offer_cant_be_used_edge_case',
            )}
          </h3>
          <div>
            <span>
              {I18n.t(
                'phrase.offers.mktplace_offers_body_offer_cant_be_used_edge_case',
              )}
            </span>
          </div>
        </div>
      </div>
    </Modal>
  </div>
);

OfferWarningModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
};
OfferWarningModal.defaultProps = {};

export default OfferWarningModal;
